module.exports = __webpack_public_path__ + "img/tajbank 1-old.8363b636.png";